"use client";
import { createContext } from "react";
const EnvironmentContext = createContext(null);
export {
  EnvironmentContext
};
